<template>
	<div>
		<template v-if="$route.params.withdraw == 'pay'">
			<paymentForm />
			<br />
			<h4 class="mt-2">Güncel Papara hesaplarımızı lütfen Canlı Destek üzerinden isteyiniz.</h4>
		</template>
		<template v-if="$route.params.withdraw == 'withdraw'">
			<withdrawForm />
		</template>
	</div>
</template>

<script>
	import paymentForm from '@/components/payments/form/extend'
	import withdrawForm from '@/components/payments/form/extendWithdraw'
    export default {
        name: "papara",
        components: {withdrawForm,paymentForm}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/extend.vue